import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-visitor-detail',
  templateUrl: './visitor-detail.component.html',
  styleUrls: ['./visitor-detail.component.scss'],
})
export class VisitorDetailComponent {
  selectedLocations: { lat: number; lng: number }[] = [];
  @Input() set visitorDetails(val: Visitor) {
    if (val) this.setVisitorDetails(val);
  }
  @Input() set orgUser(val: UserRegDetails[]) {
    this.usersList = val;
  }
  @Input() selectedCommentId: string | null;
  @Output() postVisitorComment = new EventEmitter<any>();
  @Output() closeVisitorDetail = new EventEmitter<boolean>();
  @Output() showVisitorTimeline = new EventEmitter<any>();
  @Output() updateVisitorDetails = new EventEmitter<any>();

  @ViewChild('RemoveVisitorDialog', { static: true })
  removeVisitorDialog: TemplateRef<any>;
  usersList: UserRegDetails[] = [];
  profilePicture = '';
  IdentityId = '';
  isShowTime = false;
  showVisitorDetailsForm = this.formbuilder.group({
    firstName: [''],
    lastName: [''],
    email: ['', [Validators.email]],
    phoneNumber: [''],
    visitorAddress: [''],
    visitorID: [''],
    purpose: [''],
    carRegistration: [],
    hostUserId: [''],
    hostEmail: [''],
    hostName: [''],
    visitDateTime: [''],
    gender: [''],
    checkIn: [''],
    checkOut: [''],
    ePassValidity: [''],
    visitorCategory: [''],
    newEPassValidity: [''],
    isActive: [''],
    securityStatus: [''],
    orgID: [''],
    isLocationVerify: [false],
    isTwoFactor: [false],
    visitorLocation: [''],
  });
  screenSize: ScreenType;
  isUpdateVisitorDetails = false;
  isUpdatePassValidty = false;
  minDate: any;
  maxDate: any;
  currentYear: any;
  selectedVisitorDetails: Visitor;
  constructor(
    private formbuilder: FormBuilder,
    private screen: AumyeResponsiveScreenService,
    private dialog: MatDialog,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.showVisitorDetailsForm.get('isTwoFactor').disable();
    this.showVisitorDetailsForm.get('isLocationVerify').disable();
  }
  setVisitorDetails(val: Visitor) {
    this.showVisitorDetailsForm.reset();
    const visitDateTime = new Date(val.visitDateTime + 'Z');
    const ePassValidity = new Date(val.ePassValidity + 'Z');
    this.showVisitorDetailsForm.controls.visitDateTime.setValue(
      moment(visitDateTime).format('DD/MM/YYYY, h:mm:ss A')
    );

    if (val.checkIn) {
      const checkIn = new Date(val.checkIn + 'Z');
      this.showVisitorDetailsForm.controls.checkIn.setValue(
        moment(checkIn).format('DD/MM/YYYY, h:mm:ss A')
      );
    } else {
      this.showVisitorDetailsForm.controls.checkIn.setValue('');
    }
    if (val.checkOut) {
      const checkOut = new Date(val.checkOut + 'Z');
      this.showVisitorDetailsForm.controls.checkOut.setValue(
        moment(checkOut).format('DD/MM/YYYY, h:mm:ss A')
      );
    } else {
      this.showVisitorDetailsForm.controls.checkOut.setValue('');
    }
    this.showVisitorDetailsForm.controls.firstName.setValue(val.firstName);
    this.showVisitorDetailsForm.controls.lastName.setValue(val.lastName);
    this.showVisitorDetailsForm.controls.email.setValue(val.email);
    this.showVisitorDetailsForm.controls.phoneNumber.setValue(val.phoneNumber);
    this.showVisitorDetailsForm.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.showVisitorDetailsForm.controls.visitorID.setValue(val.visitorID);
    this.showVisitorDetailsForm.controls.purpose.setValue(val.purpose);
    this.showVisitorDetailsForm.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.showVisitorDetailsForm.controls.hostName.setValue(val.hostName);
    this.showVisitorDetailsForm.controls.hostUserId.setValue(val.hostUserId);
    this.showVisitorDetailsForm.controls.visitorCategory.setValue(
      val.visitorCategory
    );
    this.showVisitorDetailsForm.controls.ePassValidity.setValue(
      moment(ePassValidity).format('DD/MM/YYYY, h:mm:ss A')
    );
    this.currentYear = ePassValidity.getFullYear();
    this.minDate = new Date(
      this.currentYear + 0,
      ePassValidity.getMonth(),
      ePassValidity.getDate()
    );
    this.showVisitorDetailsForm.controls.securityStatus.setValue(
      val.securityStatus.toString()
    );
    this.showVisitorDetailsForm.controls.orgID.setValue(val.orgID);
    this.showVisitorDetailsForm.controls.isLocationVerify.setValue(
      val.isLocationVerify
    );
    this.showVisitorDetailsForm.controls.isTwoFactor.setValue(val.isTwoFactor);
    try {
      this.showVisitorDetailsForm.controls.visitorLocation.setValue(
        val.visitorLocation ? JSON.parse(val.visitorLocation)[0]?.label : ''
      );
    } catch (e) {
      // If JSON.parse fails, log the error and set the value to an empty string
      console.warn('Error parsing visitorLocation:', e);
      this.showVisitorDetailsForm.controls.visitorLocation.setValue(
        val.visitorLocation
      );
    }
    // this.showVisitorDetailsForm.controls.visitorLocation.setValue(
    //   val.visitorLocation
    // );
    this.maxDate = new Date(this.currentYear + 0, new Date().getMonth() + 6, 0);
    this.selectedLocations = val.visitorLocation
      ? JSON.parse(val.visitorLocation)
      : [];
    this.profilePicture = val.profilePicture;
    this.IdentityId = val.identityID;
    this.isShowTime = false;
    this.selectedVisitorDetails = val;
  }
  onClose() {
    this.closeVisitorDetail.emit();
  }
  visitorTimelineToggle() {
    this.isShowTime = !this.isShowTime;
    this.showVisitorTimeline.emit(this.isShowTime);
  }
  formatDate(date: any): string | null {
    if (!date) return null;
    const parsedDate = new Date(date);
    return isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString();
  }
  toggleVisitorEdit() {
    if (this.isUpdateVisitorDetails) {
      console.log(this.showVisitorDetailsForm.value);
      const formattedData = {
        ...this.showVisitorDetailsForm.value,
        visitDateTime: this.formatDate(
          this.showVisitorDetailsForm.get('visitDateTime')?.value
        ),
        ePassValidity: this.formatDate(
          this.showVisitorDetailsForm.get('ePassValidity')?.value
        ),
        newEPassValidity: this.formatDate(
          this.showVisitorDetailsForm.get('newEPassValidity')?.value
        ),
        checkIn: this.formatDate(
          this.showVisitorDetailsForm.get('checkIn')?.value
        ),
        checkOut: this.formatDate(
          this.showVisitorDetailsForm.get('checkOut')?.value
        ),
      };
      console.log(formattedData);
      this.updateVisitorDetails.emit(formattedData);
    } else {
      this.isUpdateVisitorDetails = true;
      this.showVisitorDetailsForm.get('isTwoFactor').enable();
      this.showVisitorDetailsForm.get('isLocationVerify').enable();
    }
  }
  togglePassValidity() {
    this.isUpdatePassValidty = !this.isUpdatePassValidty;
  }
  onRemoveVisitor() {
    const dialogref = this.dialog.open(this.removeVisitorDialog, {
      disableClose: true,
    });
    dialogref.afterClosed().subscribe((result: any) => {
      if (result) {
        this.showVisitorDetailsForm.controls.isActive.setValue('0');
        const formattedData = {
          ...this.showVisitorDetailsForm.value,
          visitDateTime: this.formatDate(
            this.showVisitorDetailsForm.get('visitDateTime')?.value
          ),
          ePassValidity: this.formatDate(
            this.showVisitorDetailsForm.get('ePassValidity')?.value
          ),
          newEPassValidity: this.formatDate(
            this.showVisitorDetailsForm.get('newEPassValidity')?.value
          ),
          checkIn: this.formatDate(
            this.showVisitorDetailsForm.get('checkIn')?.value
          ),
          checkOut: this.formatDate(
            this.showVisitorDetailsForm.get('checkOut')?.value
          ),
        };
        this.updateVisitorDetails.emit(formattedData);
      }
    });
  }
  getLocationAddress(val: any) {
    const lat = val.lat;
    const lng = val.lng;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18'}`;

    return this.http.get(geocodeUrl);
  }
  viewIncident: string = null;
  onClickOpenMap() {
    const dialogRef = this.dialog.open(MapsLocationDialogComponent, {
      data: { header: 'Verification Location', isMultipleMarker: true },
    });
    dialogRef.afterClosed().subscribe((x: string) => {
      if (x) {
        this.getLocationAddress(JSON.parse(x)).subscribe((response: any) => {
          if (response && response.results && response.results.length > 0) {
            const address = response.results[0].formatted_address;
            this.viewIncident = address;
            this.cdr.detectChanges();
          }
        });
        this.selectedLocations.push(JSON.parse(x));
        this.showVisitorDetailsForm.controls['visitorLocation'].setValue(
          JSON.stringify(this.selectedLocations)
        );
        this.cdr.detectChanges();
      }
    });
  }
  onPostVisitorComment(val: any) {
    this.postVisitorComment.emit(val);
  }
  ScreenType = ScreenType;
}
